export enum TransactionTypesEnum {
  Intent = 'intent',
  Payout = 'payout',
  Refund = 'refund',
  Dispute = 'dispute',
  Invoice = 'invoice',
  Adjustment = 'adjustment',
}

export enum PaymentReportTotalTypes {
  Amount = 'amount',
  ClientFee = 'clientTransactionFee',
  TotalInvoiced = 'totalInvoiced',
  NetProceeds = 'netProceeds',
  TransactionFees = 'transactionFees',
}

export enum PaymentReportColumnNames {
  ClientName = 'CLIENT NAME',
  Conversation = 'CONVERSATION',
  TransactionType = 'TRANSACTION TYPE',
  PaymentStatus = 'PAYMENT STATUS',
  Date = 'DATE',
  Disbursed = 'DISBURSED',
  Amount = 'AMOUNT',
  ClientFee = 'CLIENT FEE',
  TotalInvoiced = 'TOTAL INVOICED',
  TransactionFees = 'TRANSACTION FEES',
  NetProceeds = 'NET PROCEEDS',
  SentBy = 'SENT BY',
  PaymentMethod = 'PAYMENT METHOD',
  CardBrand = 'CARD BRAND',
  CardType = 'CARD TYPE',
  Last4 = 'LAST 4',
  Actions = 'ACTIONS',
  Created = 'CREATED',
  ArrivalDate = 'ARRIVAL DATE',
  LinkedTransactions = 'LINKED TRANSACTIONS',
  ClientId = 'CLIENT ID',
  WritebackStatus = 'WRITEBACK STATUS',
  Invoices = 'INVOICES',
  Terminal = 'TERMINAL NAME',
  DevMode = '----------------------------------------------- |✭ DEV MODE ✭ financialTransactionId | -----------------------------------------------',
  EndOfDay = 'END OF DAY',
  PaidAt = 'PAID AT',
  DisputeStatus = 'DISPUTE STATUS',
  DisputeReason = 'DISPUTE REASON',
  Manage = 'MANAGE',
}

export enum PaymentReportColumnSelectors {
  ClientName = 'clinicPetParentName',
  Conversation = 'conversation',
  TransactionType = 'transactionType',
  PaymentStatus = 'paymentStatus',
  Date = 'date',
  Disbursed = 'disbursed',
  Amount = 'amount',
  ClientFee = 'clientTransactionFee',
  TotalInvoiced = 'totalInvoiced',
  TransactionFees = 'transactionFees',
  NetProceeds = 'netProceeds',
  SentBy = 'sentBy',
  PaymentMethod = 'paymentMethod',
  CardBrand = 'cardBrand',
  CardType = 'cardType',
  Last4 = 'last4',
  Actions = 'actions',
  Created = 'createdAt',
  ArrivalDate = 'arrivalDate',
  LinkedTransactions = 'linkedTransactions',
  ClientId = 'clinicPetParentPimsId',
  WritebackStatus = 'writebackStatus',
  Invoices = 'invoices',
  Terminal = 'terminal',
  DevMode = 'developerMode',
  EndOfDay = 'endOfDay',
  PaidAt = 'paidAt',
  DisputeStatus = 'disputeStatus',
  DisputeReason = 'disputeReason',
  Manage = 'manage',
}
